import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import {
  SmallDropdown,
} from '@americanexpress/consumer-travel-base';
import { setAirlineAction } from '../../../ducks/filtersDuck';
import { getAirline } from '../../../selectors/filtersSelectors';
import themeContext from '../../../context/themeContext';
import { useAirlines } from '../../../hooks/useAirlines';

const mapAirlinesToDropdown = (airlines) => airlines.map((airline) => ({
  label: airline.name,
  value: airline.code,
}));

const AirlineDropdown = () => {
  const theme = useContext(themeContext);
  const { formatMessage } = useIntl();
  const airline = useSelector(getAirline);
  const dispatch = useDispatch();
  const onChange = (airlineChange) => {
    dispatch(setAirlineAction(airlineChange));
  };

  const {
    data: airlines,
  } = useAirlines();

  const showAirlineDropdown = Array.isArray(airlines) && airlines.length > 0;

  if (!showAirlineDropdown) {
    return null;
  }

  const airlineOptions = mapAirlinesToDropdown(airlines);
  const formattedAirlineOptions = [
    { label: formatMessage({ id: 'all_airlines' }), value: '' },
    ...airlineOptions,
  ];

  return (
    <div className="col-lg-3 col-sm-6 col-xs-12 flex" data-testid="AirlineDropdown">
      <SmallDropdown
        id="airline-dropdown"
        ariaLabel={formatMessage({ id: 'airlineDropdown.ariaLabel' })}
        theme={theme}
        value={airline}
        onChange={onChange}
        options={formattedAirlineOptions}
      />
    </div>
  );
};

export default AirlineDropdown;
